//====================================================
//  Function: Reposition Advanced modal
//====================================================

function partsRepositionAdvancedOrder() {
  $(".advanced-order").closest("#colorbox").removeClass("advanced-order-modal");
  if ($(".advanced-order").length) {
    var advancedOrder = $(".advanced-order");
    var productPrice = $(
      ".p-info-wrapper .p-final-price-wrapper .price-final-holder"
    )
      .text()
      .trim();
    advancedOrder.find(".h2").append("<span>" + productPrice + "</span>");
    $("#cboxOverlay").hide();
    advancedOrder.closest("#colorbox").addClass("advanced-order-modal");

    if (addProductToBasketStyle) {
      $(".advanced-order-modal").addClass("advanced-order-modal-no-close");
      advancedOrder.addClass("custom-style--bg");
    } else {
      var imgSrc = $(
        ".wm-gallery-thumbs-box .carousel__slide:first-child .wm-gallery-img"
      ).attr("src");
      $(
        "<div class='advanced-product'><img src=" + imgSrc + "></div>"
      ).insertBefore(advancedOrder.find(".h2"));
      $(".advanced-product").append(advancedOrder.find(".h2"));
    }
  }
}
// add notice to cart popup - prompting users to enter custom dimensions for their mattress
function customMattressNotice() {
  var customMattressCategoryTerm;
  var customMattressHtml;
  switch(lang) {
    case 'sk':
      customMattressCategoryTerm = 'matrace na mieru';
      customMattressHtml = '<p class="alert-w alert-w-info"><strong>Upozornenie:</strong> V poznámke pri dokončení objednávky nám nezabudnite napísať želané rozmery vášho matraca na mieru.</p>';
      break;
    case 'hu':
      customMattressCategoryTerm = 'méretre gyártott matracok';
      customMattressHtml = '<p class="alert-w alert-w-info"><strong>Figyelmeztetés:</strong> Kérem, a rendelés befejezése előtt ne felejtse el beírni a megjegyzésbe a kívánt méretet.</p>';
      break;
    case 'cs':
      customMattressCategoryTerm = 'matrace na míru';
      customMattressHtml = '<p class="alert-w alert-w-info"><strong>Upozornění:</strong> V poznámce při dokončení objednávky nám prosím nezapomeňte napsat požadované rozměry vašeho matrace na míru.</p>';
      break;
    case 'ro':
      customMattressCategoryTerm = 'saltele la comandă';
      customMattressHtml = '<p class="alert-w alert-w-info"><strong>Avertisment:</strong> În nota de finalizare a comenzii, nu uitați să ne scrieți dimensiunile dorite ale saltelei personalizate.</p>';
      break;
    case 'bg':
      customMattressCategoryTerm = 'matrace na mieru';
      customMattressHtml = '<p class="alert-w alert-w-info"><strong>Upozornenie:</strong> V poznámke pri dokončení objednávky nám nezabudnite napísať želané rozmery vášho matraca na mieru.</p>';
      break;
    case 'hr':
      customMattressCategoryTerm = 'madraci po mjeri';
      customMattressHtml = '<p class="alert-w alert-w-info"><strong>Upozorenje:</strong> U napomeni pri završetku narudžbe ne zaboravite nam napisati željene dimenzije vašeg madraca po mjeri.</p>';
      break;
    case 'sl':
      customMattressCategoryTerm = 'vzmetnice po meri';
      customMattressHtml = '<p class="alert-w alert-w-info"><strong>Opozorilo:</strong> V opombi pri zaključevanju naročila nam obvezno sporočite želene dimenzije vaše vzmetnice po meri.</p>';
      break;
    case 'uk':
      customMattressCategoryTerm = 'matrace na mieru';
      customMattressHtml = '<p class="alert-w alert-w-info"><strong>Upozornenie:</strong> V poznámke pri dokončení objednávky nám nezabudnite napísať želané rozmery vášho matraca na mieru.</p>';
      break;
    default:
      return;
  }
  if ($('#navigation-2 span').text().toLowerCase().includes(customMattressCategoryTerm)) {
      $(customMattressHtml).insertBefore($(document).find("#cboxLoadedContent .advanced-order .extras-wrap"));
  }
}
